import React, { useState } from 'react';
import authService from '../services/authService';
import { LoginRequest, PrincipalType } from '../types/auth';
import { AirplaneIcon, EyeIcon } from './icons';
import './LoginPage.css';

interface LoginPageProps {
  onLoginSuccess: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState<LoginRequest>({
    principal: '',
    password: ''
  });
  const [principalType, setPrincipalType] = useState<PrincipalType>('email');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePrincipalTypeChange = (type: PrincipalType) => {
    setPrincipalType(type);
    setFormData(prev => ({ ...prev, principal: '' }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await authService.login(formData);
      console.log('Login successful:', result);
      
      // Проверяем, что токены действительно сохранены
      const accessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');
      
      if (accessToken && refreshToken) {
        console.log('Tokens saved successfully, calling onLoginSuccess');
        // Сразу переходим на главную страницу
        onLoginSuccess();
      } else {
        console.error('Tokens not saved properly');
        setError('Ошибка сохранения токенов');
      }
      
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ошибка входа');
      console.error('Login failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const getPrincipalPlaceholder = () => {
    return principalType === 'email' ? 'Email' : 'Имя пользователя';
  };

  const getPrincipalType = () => {
    return principalType === 'email' ? 'email' : 'text';
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="logo-section">
          <AirplaneIcon className="airplane-icon" size={40} />
          <span className="logo-text">Airplanes</span>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="principal-type-selector">
            <button
              type="button"
              className={`type-button ${principalType === 'email' ? 'active' : ''}`}
              onClick={() => handlePrincipalTypeChange('email')}
            >
              Email
            </button>
            <button
              type="button"
              className={`type-button ${principalType === 'username' ? 'active' : ''}`}
              onClick={() => handlePrincipalTypeChange('username')}
            >
              Имя пользователя
            </button>
          </div>

          <div className="input-group">
            <input
              type={getPrincipalType()}
              name="principal"
              placeholder={getPrincipalPlaceholder()}
              value={formData.principal}
              onChange={handleInputChange}
              required
              className="input-field"
            />
          </div>

          <div className="input-group">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Пароль"
              value={formData.password}
              onChange={handleInputChange}
              required
              className="input-field"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="password-toggle"
            >
              <EyeIcon className="eye-icon" size={20} />
            </button>
          </div>

          <div className="forgot-password">
            <a href="#" className="forgot-link">Забыл пароль?</a>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>

        <div className="nfc-login">
          <span>Вход через <strong>NFC</strong></span>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage; 